'use strict';

var template         = require('../../templates/settings/SettingsLayout.ejs');
var tooltip          = require('helpers/tooltip');
var PayrollItemsView = require('employer/views/settings/PayrollItems.js');

module.exports = Backbone.View.extend({
    initialize: function(options) {
        //FIXME NEVER extend this with options
        _.extend(this, options);
        this.render();
    },

    render: function() {
        this.$el.html(template({tab: this.tab}));

        return this;
    },

    renderContent: function(options) {
        options.defaultPayrollItems = true;
        options.showReliefOptions = true;
        options.templateExtra = {hideActionButtons: !app.user.isSuperAdmin()};

        if (this.tab === 'defaultPayrollItems') {
            new PayrollItemsView(
                _.extend({el: this.$('.js-defaultPayrollItems')}, options)
            );
            this.$('.js-defaultPayrollItems-tab').addClass('active');
        }

        this.$('input[type="checkbox"]').iCheck({
            checkboxClass: 'icheckbox_square-blue'
        });
        tooltip.init(this);
    },

    hideLoader: function() {
        this.$('.js-loading-tab').removeClass('active');
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/settings/SettingsLayout.js